import { apiClient } from "../apiClient"

export const TIEN_THUA_HOC_SINH_API_RESOURCE = "tien-thua-hoc-sinh"
export const tienThuaHocSinhApi = {
    SelectAll: () => apiClient.get(`${TIEN_THUA_HOC_SINH_API_RESOURCE}`),
    SelectByHocSinh: (ts_hocsinh_id: number) => apiClient.get(`${TIEN_THUA_HOC_SINH_API_RESOURCE}/hoc-sinh/${ts_hocsinh_id}`)
}
